<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <v-card-title>Временные абоненты шлагбаума</v-card-title>
      <div>
        <BaseTextField
          v-model="telephoneSearch"
          type-input="string"
          :is-button="false"
          label="Номер телефона"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="CreationTemporaryAbonent"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создание временного абонента</span>
      </v-tooltip>
      <v-dialog v-model="dialogNew" max-width="650" content-class="dialog-border-radius">
        <create-temporary-abonent
          :active.sync="dialogNew"
          icon="mdi-account-clock-outline"
          message="Новый абонент (временный)"
          @save="createTemporaryAbonent"
          @close="dialogNew = false"
        />
      </v-dialog>
      <v-dialog :value="!!currentEditItem" max-width="650" content-class="dialog-border-radius" @input="closeEditDialog">
        <create-temporary-abonent
          v-if="currentEditItem"
          :active.sync="editDialogActive"
          :edit-item="currentEditItem"
          icon="mdi-account-clock-outline"
          message="Редактирование временного абонента"
          @update="updateTemporaryAbonentHandler"
          @close="closeEditDialog"
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateListAbonents"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
      :footer-props="{
        'items-per-page-options': [5, 15, 20, 50, 100],
        showFirstLastPage: true
      }"
      :items-per-page="20"
    >
      <template v-slot:item.telephone="{ item }">
        <div v-if="item.telephone">
          <div>
            <v-btn
              large
              outlined
              prepe
              color="aliceblue"
              style="height: 20px"
              class="routerLink"
              @contextmenu.prevent="copyToClipboard(item.telephone)"
            >
              <li>{{ formatPhoneNumber(item.telephone) }}</li>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:item.guest="{ item }">
        <div v-if="item.date_begin && item.date_end">
          {{ ruDateFormat(item.date_begin, true) }} - {{ ruDateFormat(item.date_end, true) }}
        </div>
      </template>
      <template v-slot:item.created_at="{ item }">
          {{ ruDateFormat(item.created_at) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <template v-if="$checkPermission('update_car_number_barrier')">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn
                    icon
                    text
                    tile
                    small
                    class="btn__icon ml-4 mr-1"
                    width="18"
                    height="18"
                    :disabled="isTemporaryAbonentFromClient(item)"
                    @click.stop="!isTemporaryAbonentFromClient(item) && $set(dialogWarning, item.id, true)"
                  >
                    <v-icon size="large">mdi-close</v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ isTemporaryAbonentFromClient(item) ? 'Абонент создан от клиента (без домофона). Удаление только через карточку клиента.' : 'Удалить' }}</span>
            </v-tooltip>
            <v-dialog v-if="!isTemporaryAbonentFromClient(item)" v-model="dialogWarning[item.id]" max-width="420" content-class="dialog-border-radius">
              <baseDeleteModal
                :active.sync="dialogWarning[item.id]"
                @close="$set(dialogWarning, item.id, false)"
                @submit="deleteTemAbonents(item.id, item.car_number)"
                messageTitle="Удалить «временного» абонента?"
                messageText="Подтверждая, вы удалите «временного» абонента. Так же автомобильный номер будет удален из базы номеров."
              />
            </v-dialog>
          </template>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogNoticeResComplex" max-width="500" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Внимание
        </v-card-title>
        <v-card-text>
          <p>
            Этот шлагбаум связан с жилым комплексом. Вы можете перейти в раздел управления
            <b>{{ getResidentialComplexName(barrier.residential_complex_id) }}</b>
            , чтобы работать с шлагбаумами ЖК. Или же вы можете продолжить работать с этим шлагбаумом здесь.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            class="text-none"
            outlined
            dark
            right
            rounded
            :to="`/residential-complexes/${barrier.residential_complex_id}/view`"
          >
            Перейти в Жилой комплекс
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="text-none"
            outlined
            dark
            right
            rounded
            @click.prevent="continueHere()"
          >
            Продолжить здесь
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseTextField from '../../../BaseTextField';
import baseDeleteModal from '../../../BaseDeleteModal';
import CreateTemporaryAbonent from '@/components/accounts/CreateTemporaryAbonent';
import formatPhoneNumber from '../../../../mixins/formatPhoneNumber';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'ListTemporaryAbonents',
  mixins: [formatPhoneNumber, ruDateFormatMixin],
  props: {
    barrier: {
      type: Object,
    },
    resComplexName: Array,
    responseTemporaryAbonents: Array,
    getData: Function,
  },
  components: { CreateTemporaryAbonent, BaseTextField, baseDeleteModal },
  data () {
    return {
      isCreated: true,
      lastCopiedText: null,
      filters: {},
      filterAbonents: {},
      telephoneSearch: '',
      carSearch: '',
      startDate: '',
      endDate: '',
      importFile: null,
      dialogWarning: {},
      dialogNew: false,
      dialogImport: false,
      dialogNoticeResComplex: false,
      dialogEdit: {},
      currentEditItem: null,
      editDialogActive: false,
      totalAccounts: 0,
      headersTable: [
        { text: 'id', value: 'id', sortable: false, align: 'center' },
        { text: 'Имя', value: 'name', sortable: false, align: 'center' },
        { text: 'телефон', value: 'telephone', sortable: false, align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Промежуток действия номера', value: 'guest', sortable: false, align: 'center', width: '20%' },
        { text: 'Комментарий', value: 'comment', sortable: false, align: 'center' },
        { text: 'Дата и время создания', value: 'created_at', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, align: 'center', width: '5%' },
      ],
    };
  },
  created () {
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.telephoneSearch) {
        return this.responseTemporaryAbonents.filter(item => {
          return item.telephone !== null &&
            String(item.telephone).toLowerCase().includes(this.telephoneSearch.toLowerCase());
        });
      } else {
        return this.responseTemporaryAbonents;
      }
    },
  },
  methods: {
    ...mapActions({
      updateCarNumber: 'Barriers/updateCarNumber',
      loadTemporaryAbonents: 'TemporaryAbonent/loadTemporaryAbonents',
      updateTemporaryAbonent: 'TemporaryAbonent/updateTemporaryAbonent',
      newTemporaryAbonent: 'TemporaryAbonent/newTemporaryAbonent',
      deleteTemporaryAbonent: 'TemporaryAbonent/deleteTemporaryAbonent',
    }),
    CreationTemporaryAbonent () {
      if (this.barrier.residential_complex_id) {
        this.dialogNoticeResComplex = true;
        return;
      }
      this.dialogNew = true;
    },
    continueHere () {
      this.dialogNoticeResComplex = false;
      this.dialogNew = true;
    },
    getResidentialComplexName (id) {
      const complex = this.resComplexName.find(item => item.id === id);
      return complex ? complex.name : '';
    },
    async copyToClipboard (telephone) {
      if (this.lastCopiedText === telephone) {
        return;
      }
      try {
        await navigator.clipboard.writeText(telephone);
        this.lastCopiedText = telephone;
        this.$flash_success('Телефон скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать номер телефона');
      }
    },
    isTemporaryAbonentFromClient (item) {
      return !!(item && (item.client_id != null || item.from_client));
    },
    async updateListAbonents () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    createTemporaryAbonent (actionShould, carNumber, notification, telephone, nameAbonent, comment, date) {
      this.updateTableNumber(actionShould, carNumber, notification, date);
      const dataAbonent = {
        telephone: telephone,
        barrier_ids: [this.barrier.id],
      };
      if (nameAbonent) {
        dataAbonent.name = nameAbonent;
      }
      if (comment) {
        dataAbonent.comment = comment;
      }
      if (date.length) {
        dataAbonent.date_begin = date[0];
        dataAbonent.date_end = date[1];
      }
      if (carNumber) {
        dataAbonent.car_number = carNumber;
      }
      this.newTemporaryAbonent(dataAbonent)
        .then(() => {
          this.$flash_success('Аккаунт успешно создан');
        })
        .catch(e => console.error(e));
    },
    async updateTableNumber (actionShould, carNumber, notification, date) {
      const dataCar = {
        action_should: actionShould,
        car_number: carNumber,
        notify: notification ? 'on' : 'off',
      };
      if (date.length) {
        dataCar.start_date = date[0];
        dataCar.end_date = date[1];
      }
      await this.updateCarNumber({
        id: this.$route.params.id,
        data: dataCar,
      })
        .then(async () => {
          await this.getData();
          this.$flash_success('Дейсвие успешно сохранено!');
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при обновлении таблицы');
          }
        });
    },
    deleteTemAbonents (id, carNumber) {
      this.deleteTemporaryAbonent({
        id: id,
      })
        .then(async () => {
          this.$flash_success('Абонент успешно удален');
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при удалении абонента');
        });
      const date = [];
      this.updateTableNumber('remove', carNumber, false, date);
    },
    openEditDialog (item) {
      this.currentEditItem = item;
      this.editDialogActive = true;
    },
    closeEditDialog () {
      this.currentEditItem = null;
      this.editDialogActive = false;
    },
    async updateTemporaryAbonentHandler (id, actionShould, carNumber, notification, telephone, nameAbonent, comment, date, address, apartment) {
      const dataAbonent = {
        telephone: telephone,
        barrier_ids: [this.barrier.id],
      };
      if (nameAbonent) {
        dataAbonent.name = nameAbonent;
      }
      dataAbonent.comment = comment || '';
      if (date.length) {
        dataAbonent.date_begin = date[0];
        dataAbonent.date_end = date[1];
      } else {
        dataAbonent.date_begin = null;
        dataAbonent.date_end = null;
      }
      if (carNumber) {
        dataAbonent.car_number = carNumber;
      }

      try {
        await this.updateTemporaryAbonent({
          id: id,
          data: dataAbonent,
        });
        this.$flash_success('Абонент успешно обновлен');
        this.closeEditDialog();
        await this.getData();
      } catch (err) {
        console.error(err);
        this.$flash_warning('Ошибка при обновлении абонента');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: #000000;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
</style>
